import React from "react";

const index = (props) => {
  return (
    <div className="text-center mx-auto w-100" style={{color:'#7A7A7A'}}>{props.text}</div>
  );
};

export default index;
